import { render, staticRenderFns } from "./PageEditorContentMoveDownBtn.vue?vue&type=template&id=7ebc8906&scoped=true"
import script from "./PageEditorContentMoveDownBtn.vue?vue&type=script&lang=js"
export * from "./PageEditorContentMoveDownBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebc8906",
  null
  
)

export default component.exports